import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-2xl font-semibold">lander_manager</h1>
      <nav className="flex gap-4">
        <Link to="/sign-in" className="underline">
          Sign in
        </Link>
        <Link to="/dashboard" className="underline">
          Dashboard
        </Link>
      </nav>
    </main>
  );
}
